export function dispatch (eventName: string, detail: any): void {
    eventName.split(' ').forEach(x => {
        window.dispatchEvent(new CustomEvent(x, { detail }));
    });
}

export function attach (eventName: string, func: EventListenerOrEventListenerObject): void {
    eventName.split(' ').forEach(x => {
        window.addEventListener(x, func);
    });
}

export function detach(eventName: string, func: EventListenerOrEventListenerObject): void {
    window.removeEventListener(eventName, func);
}

export function dispatchWindowEvent(eventName: string): void {
    window.dispatchEvent(createEvent(eventName));
}

export function createEvent(eventName: string): Event {
    if(typeof(Event) === "function") {
        return new Event(eventName, { bubbles: true, cancelable: true });
    } else {
        let event = document.createEvent('Event');
        event.initEvent(eventName, true, true);
        return event;
    }
}

let timers: any = {};
export function waitForFinalEvent(callback: Function, ms: number, uniqueId: string) {
    if (!uniqueId) {
        uniqueId = "Don't call this twice without a uniqueId";
      }
      if (timers[uniqueId]) {
        clearTimeout(timers[uniqueId]);
      }
      timers[uniqueId] = setTimeout(callback, ms);
}

export default {
    dispatch,
    attach,
    detach
}


//Centralized handling of window.onbeforeunload
let beforeUnloadChecks = {}, hasPrompted = false;
export function addBeforeUnload(identifier: string, evaluate: (() => Boolean) | Boolean = true) {
    beforeUnloadChecks[identifier] = evaluate;
}

export function removeBeforeUnload(identifier?: string) {
    if(identifier) {
        delete beforeUnloadChecks[identifier];
    } else {
        beforeUnloadChecks = {};
    }
}

attach("formDataClear", () => {
    removeBeforeUnload();
});

attach("formDataChanged", () => {
    addBeforeUnload("form");
});

attach("formDataSaved", () => {
    removeBeforeUnload("form");
});

if('onbeforeunload' in window) {
    window.onbeforeunload = function () {
        let changeText = getChangedText(beforeUnloadChecks);
        if(changeText && !hasPrompted) {
            hasPrompted = true;//Prevent multiple popups which happens sometimes in Chrome & IE
            setTimeout(() => setTimeout(() => hasPrompted = false, 1000), 1);//This is the best (but hacky) way to deterime if the user clicked 'cancel' to stay on the page
            return changeText;
        }
    }
}

function getChangedText(checks) {
    let identifier = "";
    for(let i in checks) {
        if(checks[i] === true) {
            if(identifier) {
                identifier += ", ";
            }
            identifier += i;
        } else if (typeof checks[i] === "function") {
            if(checks[i]()) {
                if(identifier) {
                    identifier += ", ";
                }
                identifier += i;
            }
        }
    }
    if(identifier) {
        console.log("Changes have been made: ", identifier);
        return `Changes to the ${identifier} have not been saved.  Continue?`;
    }
    return null;
}